import styled, { css } from 'styled-components';
import { handleQuerySmall } from '../candidate-interview/candidate-interview-styled';

import { BaSeTheme } from '@base/react';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background-color: ${BaSeTheme.colors.defaultColors.black};

  background-repeat: no-repeat;
  ${({ imgBackground, imgGraph, isDesktop }) =>
    isDesktop
      ? css`
          background-image: url(${imgBackground});
          background-size: cover;
        `
      : css`
          background-image: url(${imgGraph});
          background-size: cover;
        `}

  ${handleQuerySmall(css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  `)}
`;

export const Background = styled.div`
  width: 100vw;

  display: flex;
  flex-direction: column;

  background-color: ${BaSeTheme.colors.defaultColors.black};

  ${({ imgBackground }) =>
    css`
      background-image: url(${imgBackground});
    `};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  &::before {
    position: fixed;
    content: '';
    width: 100vw;
    display: block;
    top: 0;
    right: 0;
    background: radial-gradient(
      circle at top right,
      ${({ isAuthenticated, primaryColor }) =>
          isAuthenticated ? primaryColor ?? '#175e8b' : primaryColor} -30vh,
      transparent 40vw
    );
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ContentWoman = styled.div`
  position: fixed;

  img {
    width: 70%;
    margin-top: 60px;
  }
`;

export const Wrapper = styled.div`
  max-width: 430px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 400px;
  padding-left: 560px;
  margin: 0 20px 20px 20px;

  ${handleQuerySmall(css`
    justify-content: center;
    align-items: center;
    margin-top: 24px;
    padding-top: 0px;
    padding-left: 0px;
  `)}
`;

export const ContentHeader = styled.div`
  width: 100%;
  height: 60px;
`;
